import React from "react";
import "./style.css";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import BannerInput from "../bannerInput";
import AirportResults from "./airport-results";

const ContainerSearch = ({
  onChange,
  value,
  onClick,
  placeholder,
  options,
  loading,
  name,
  excludeCityCode,
}) => {
  return (
    <div className="container-search airport-search">
      <div className="airport-search__input">
        <SearchRoundedIcon className="airport-search__input-icon" />
        <BannerInput
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          autoFocus
        />
      </div>

      <div className="airport-search__body">
        <AirportResults
          query={value}
          results={options}
          loading={loading}
          onSelect={onClick}
          excludeCityCode={excludeCityCode}
        />
      </div>
    </div>
  );
};

export default ContainerSearch;
